import { render, staticRenderFns } from "./EditorHeaderButtonsGroup.vue?vue&type=template&id=54e4f20b&scoped=true&"
import script from "./EditorHeaderButtonsGroup.vue?vue&type=script&lang=js&"
export * from "./EditorHeaderButtonsGroup.vue?vue&type=script&lang=js&"
import style0 from "./EditorHeaderButtonsGroup.vue?vue&type=style&index=0&id=54e4f20b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54e4f20b",
  null
  
)

export default component.exports